/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Send = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.40446 2.65031C3.83922 2.37626 3.16307 2.48344 2.7103 2.91887C2.25752 3.35431 2.12403 4.02575 2.37581 4.60126L5.61278 12L2.37581 19.3988C2.12403 19.9743 2.25752 20.6458 2.7103 21.0812C3.16307 21.5166 3.83922 21.6238 4.40446 21.3498L20.9045 13.3498C21.4216 13.099 21.75 12.5748 21.75 12C21.75 11.4253 21.4216 10.9011 20.9045 10.6503L4.40446 2.65031ZM6.92194 12.75L3.75005 20L20.25 12L3.75005 4.00004L6.92191 11.25H14.75V12.75H6.92194Z"
                        fill={color}
                    />
                </svg>
        );
    };
